import {
  BiGalleryCategory,
  BiGalleryCategoryKey,
} from '../functions/biGalleryTypes';
import { kBarCategory } from './barFixtures';
import { kBlendCategory } from './blendFixtures';
import { kComboCategory } from './comboFixtures';
import { kFormatsCategory } from './formatFixtures';
import { kFunnelCategory } from './funnelFixtures';
import { kHorizontalBarCategory } from './horizontalBarFixtures';
import { kKpiCategory } from './kpiFixtures';
import { kLineCategory } from './lineFixtures';
import { kPieCategory } from './pieFixtures';
import { kPyramidCategory } from './pyramidFixtures';
import { kRadarCategory } from './radarFixtures';
import { kStackedBarCategory } from './stackedBarFixtures';
import { kStatesCategory } from './stateFixtures';
import { kTableCategory } from './tableFixtures';

/** The gallery's pages, in the order the index lists them. */
export const kBiGalleryCategories: BiGalleryCategory[] = [
  kLineCategory,
  kBarCategory,
  kHorizontalBarCategory,
  kStackedBarCategory,
  kComboCategory,
  kPieCategory,
  kRadarCategory,
  kPyramidCategory,
  kFunnelCategory,
  kTableCategory,
  kKpiCategory,
  kBlendCategory,
  kFormatsCategory,
  kStatesCategory,
];

export function biGalleryCategory(
  key: string | undefined,
): BiGalleryCategory | null {
  return (
    kBiGalleryCategories.find(
      category => category.key === (key as BiGalleryCategoryKey),
    ) ?? null
  );
}
